import Carrinho from './Carrinho';

export default Carrinho;